import React from 'react';

const TrainIcon = (props) => {
  return (
    <img
      alt="Trasa kolejowa"
      src="/static/images/icons/place_types/train.svg"
      {...props}
    />
  );
};

export default TrainIcon;
